import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

/**
 * "Camera not listed?" — the unsupported-camera guidance. Two failure cases
 * share one modal (no port at all / firmware version missing); the detail
 * page also shows the firmware part inline under its downloads table.
 *
 * Links here must be verified by hand before release (see plan §09):
 *   https://chdk.fandom.com/wiki/Unsupported_Cameras
 *   https://chdk.fandom.com/wiki/For_Developers
 *   https://chdk.fandom.com/wiki/Adding_support_of_a_new_firmware_version
 *   https://chdk.fandom.com/wiki/CameraVersion
 */
export default class CameraHelpModal extends Modal {
  className() {
    return 'CameraHelpModal Modal--large';
  }

  title() {
    return app.translator.trans('acseven-chdk-cameras.forum.help.title');
  }

  content() {
    return (
      <div className="Modal-body CameraHelp">
        <p>{app.translator.trans('acseven-chdk-cameras.forum.help.no_port_body')}</p>
        <p>{app.translator.trans('acseven-chdk-cameras.forum.help.missing_fw_body')}</p>
        <p>
          {app.translator.trans('acseven-chdk-cameras.forum.help.wiki_body')}{' '}
          <a href="https://chdk.fandom.com/wiki/Unsupported_Cameras" target="_blank" rel="noopener">
            {app.translator.trans('acseven-chdk-cameras.forum.help.wiki_link')}
          </a>
        </p>
        <Button className="Button Button--primary" onclick={() => this.hide()}>
          {app.translator.trans('acseven-chdk-cameras.forum.help.close')}
        </Button>
      </div>
    );
  }
}
